import React from 'react';
import { useTranslation } from '@ukpostbox/frontend-framework';

type CourierLogosType = {
	value: string;
};

function CourierLogos(props: CourierLogosType) {
	const { t } = useTranslation();

	if (props.value.indexOf('DPD') > -1) {
		return (
			<img
				src={`${process.env.PUBLIC_URL}/images/dpd-logo.svg`}
				alt={`DPD ${t('logo')}`}
				style={{ maxWidth: 'calc(var(--xl-unit) * 2)' }}
			/>
		);
	}
	if (props.value.indexOf('DHL') > -1) {
		return (
			<img
				src={`${process.env.PUBLIC_URL}/images/dhl-logo.svg`}
				alt={`DHL ${t('logo')}`}
				style={{ maxWidth: 'calc(var(--xl-unit) * 2)' }}
			/>
		);
	}
	if (props.value.indexOf('Parcel') > -1) {
		return (
			<img
				src={`${process.env.PUBLIC_URL}/images/parcel-force-logo.png`}
				alt={`Parcelforce ${t('logo')}`}
				style={{ maxWidth: 'calc(var(--xl-unit) * 2)' }}
			/>
		);
	}

	return (
		<img
			src={`${process.env.PUBLIC_URL}/images/royal-mail-logo.svg`}
			alt={`Royal Mail ${t('logo')}`}
			style={{ maxWidth: 'calc(var(--xl-unit) * 2)' }}
		/>
	);
}

export { CourierLogos };
